/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaGrupoActividadEconomicaVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaGrupoActividadEconomica: React.FunctionComponent<ITablaGrupoActividadEconomicaVistaProps &
    InjectedIntlProps> = ({
    grupoActividadEconomicas,
    cargarGrupoActividadEconomica,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={grupoActividadEconomicas}
            actions={acciones(
                manejarFormulario,
                cargarGrupoActividadEconomica,
                intl.formatMessage,
                confirmarEliminacion
            )}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaGrupoActividadEconomica);
